import "./CommentThread.scss"
import Comment from "features/comments/components/Comment/Comment";

const CommentThread = ({ comments, onRefresh }) => {
  const content = comments.map(
    comment =>
      <div key={ comment.cid } className={ `thread` }>
        <Comment data={ comment } onChanged={ onRefresh }/>
        {
          comment.replies.map(comment => <Comment key={ comment.cid } data={ comment } isReply onChanged={ onRefresh }/>)
        }
      </div>
  );
  return content;
}

export default CommentThread;
